export default __webpack_public_path__ + "static/media/marker-blue-sky-orange.020d3c7a.png";